module.exports = __webpack_public_path__ + "img/account_setting.d8b823de.gif";